import { Component } from '@angular/core';

@Component({
  selector: 'app-platform-redesign',
  templateUrl: './platform-redesign.component.html',
  styleUrls: ['./platform-redesign.component.scss']
})
export class PlatformRedesignComponent {

}
